import axios from "axios";
import { baseURL } from "../utils/consts";

const getSignedImageUrl = async (uniqueIdentifier) => {
  const responseObject = {
    uniqueIdentifier,
  };

  try {
    const response = await axios.post(
      `${baseURL}/users/generateSignedImageUrl`,

      responseObject,

      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.data.payLoad;
    return data;
  } catch (err) {
    throw err;
  }
};

export default getSignedImageUrl;
